module.exports = __webpack_public_path__ + "static/heroimg2-dc10514af086a589189ccd01a505f423.jpg";